import React, { useEffect, useState } from "react";
 import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
} from "reactstrap";
import PropertyForm from "../PropertyForm"
import { useSelector } from "react-redux";
 
const CreateProperty = (props) => {
    const filter = useSelector(state=> state.adminFilter)
  const id=props.match.params.id
  const name=props.match.params.name

    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>Property</title>
                </MetaTags>
                <Container fluid>
                    <Row>
                        {filter?.path == 'allProperties' && <h4>Add New {filter.addProperty == "properties" ? 'Properties' : 'Property'}</h4>}
                        {filter?.path == 'toStandaloneProperties' && <h4>Add New {filter.addProperty == "properties" ? 'Standalone Properties' : 'Standalone Property'}</h4>}
                        {filter?.path == 'PropertiesInBuilding' && <h4>Add New {filter.addProperty == "properties" ? 'Properties Inside The Building' : 'Property Inside The Building'}</h4>}
                        {filter?.path == 'fromCompound' && <h4>Add New Property</h4>}
                     </Row>
                  <PropertyForm   CompoundData={{value:id,label:name}}  history={props.history}/>
                   
                </Container>
            </div>
        </>
    )
}

export default CreateProperty